import React, { Component } from 'react'
import { Col, Row, Button, Label } from 'reactstrap'
import {
  AvForm,
  AvGroup,
  AvInput
} from 'availity-reactstrap-validation'
import TemplateContainerMain from 'components/Template'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import icon from '../../assets/Images/icon.jpeg'
import WithReset from './actions'

class PasswordReset extends Component {
  state = {
    password: '',
    password_confirm: ''
  }

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleSubmit()
    }
  }

  handleSubmit = () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const token = urlParams.get('token');

    if (!token) {
      return this.setState({
        // We can't really do much without a token, maybe show an error
      })
    }

    this.props.onClickSubmit({
      token,
      password: this.state.password,
      password_confirm: this.state.password_confirm
    })
  }

  render = () => {
    const {
      showErrorMessage,
      showSuccessMessage,
      errorMessage,
      successMessage,
      onLoadReset
    } = this.props

    const urlParams = new URLSearchParams(this.props.location.search);
    const token = urlParams.get('token');

    console.log(token)
    return (
      <TemplateContainerMain>
        <div className="h-100">
          <Row className="h-100 no-gutters justify-content-center">
            <Col lg="8" md="12" className="h-100 d-flex bg-white justify-content-center align-items-center">
              <Col lg="9" md="10" sm="12" className="mx-auto app-login-box">
                <img src={icon} style={{ width: 400, marginLeft: -10, marginBottom: '15px' }} />
                <h4 className="mb-0">
                  <div>Reset Password</div>
                  <span>Please enter your new password.</span>
                </h4>
                <Row className="divider" />
                {!token ? (
                  <p style={{ color: '#ff0000' }}>Invalid or missing token. Please use the link provided in your email.</p>
                ) : (
                  <AvForm>
                    <Row form>
                      <Col md={6}>
                        <AvGroup>
                          <Label for="password">New Password</Label>
                          <AvInput
                            onChange={e => {
                              this.setState({ password: e.target.value })
                            }}
                            type="password"
                            name="password"
                            id="password"
                            onKeyPress={this.handleKeyPress}
                            value={this.state.password}
                            placeholder="New password here..."
                            required />
                        </AvGroup>
                      </Col>
                      <Col md={6}>
                        <AvGroup>
                          <Label for="password_confirm">Confirm Password</Label>
                          <AvInput
                            onChange={e => {
                              this.setState({ password_confirm: e.target.value })
                            }}
                            type="password"
                            name="password_confirm"
                            id="password_confirm"
                            value={this.state.password_confirm}
                            onKeyPress={this.handleKeyPress}
                            placeholder="Confirm password here..."
                            required />
                        </AvGroup>
                      </Col>
                    </Row>
                    {
                      showErrorMessage && (
                        <p style={{ color: '#ff0000' }}>
                          {errorMessage}
                        </p>
                      )}
                    {
                      showSuccessMessage && (
                        <p style={{ color: '#28a745' }}>
                          {successMessage}
                        </p>
                      )}
                    <Row className="divider" />
                    <div className="d-flex align-items-center justify-content-between">
                      <Button
                        color="link"
                        size="lg"
                        className="pl-0"
                        onClick={() => this.props.history.push('/login')}>
                        Back to Login
                      </Button>
                      <div className="ml-auto">
                        <Button
                          color={
                            (onLoadReset ||
                              this.state.password.length < 1 ||
                              this.state.password_confirm.length < 1
                            ) ? 'secondary' : 'primary'
                          }
                          size="lg"
                          disabled={
                            onLoadReset ||
                            this.state.password.length < 1 ||
                            this.state.password_confirm.length < 1
                          }
                          onClick={this.handleSubmit}>Reset Password</Button>
                      </div>
                    </div>
                  </AvForm>
                )}
              </Col>
            </Col>
          </Row>
        </div>
        {onLoadReset && <LoadingOverlay />}
      </TemplateContainerMain>
    )
  }
}

export default WithReset(PasswordReset)
